import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { actionCreators } from "./redux/sagas/totalRevenueSales/totalRevenueSales";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import DatePicker from "./smartComponents/datePicker";
import PeriodType from "./smartComponents/periodType";
import IncludeReturns from "./smartComponents/includeReturns";
import ShowExpenses from "./smartComponents/showExpenses";
import CustomDateRanges from "./smartComponents/customDateRanges";
import "./totalRevenueSalesModule.css";

export class TotalRevenueSalesModule extends React.Component {
  constructor(props) {
    super(props);
    this.resetData = this.resetData.bind(this);
    this.state = {
      filtersDirty: false,
      stickyAdded: false
    };
    this.contentRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchCurrentUser({ currentUser: this.props.currentUser });
  }

  resetData() {
    this.props.resetFilters();
    this.setState({
      filtersDirty: false
    });
  }

  renderUpdateBtn() {
    if (
      this.props.filtersDirty &
      !this.props.isLoading &
      (this.props.startDate !== "Invalid date") &
      (this.props.endDate !== "Invalid date")
    ) {
      return (
        <button className="submit override-submit" onClick={this.props.updateChart}>
          Update
        </button>
      );
    }

    return null;
  }

  renderResetBtn() {
    if (this.props.filtersDirty & !this.props.isLoading) {
      return (
        <button className="submit reset override-submit" onClick={this.resetData}>
          Reset
        </button>
      );
    }

    return null;
  }

  render() {
    const { toggles, isLoading, updatesLoading } = this.props;
    const { includeReturns = "", showExpenses = "" } = toggles;

    return (
      <div id="total-revenue-sales-root">
        {Object.keys(this.props.chartData).length ? (
          <SectionToggle
            autoHeight
            paddingBottom={0}
            height={690}
            title="Total Revenue"
            customClass="total-revenue-sales-section"
            isLoading={isLoading}
            content={
              <div>
                <div id="override-edit-selection-bar" className="edit-selections-bar">
                  <div className="top-filter">
                    <div>
                      <div>
                        {includeReturns && (
                          <div className="select-box-no-width">
                            <p>{includeReturns.label}</p>
                            <IncludeReturns label={includeReturns.label} />
                          </div>
                        )}

                        {showExpenses && (
                          <div className="select-box-no-width">
                            <p>{showExpenses.label}</p>
                            <ShowExpenses label={showExpenses.label} />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="top-right-filter">
                      <div className="select-box-no-width">
                        <p>Period Type</p>
                        <PeriodType />
                      </div>
                      <div className="select-box-no-width date-range-select-box">
                        <p>Date Range</p>
                        {!this.state.filtersDirty && <CustomDateRanges />}
                      </div>

                      <div className="date-select-box select-box-no-width multi">
                        {!this.state.filtersDirty && (
                          <>
                            <p>Date</p>
                            <DatePicker />
                          </>
                        )}
                      </div>
                      {this.renderUpdateBtn()}
                      {this.renderResetBtn()}
                    </div>
                  </div>
                </div>
                <div className="chart-root">
                  {updatesLoading ? (
                    <LoadingAnimation text="Updating data..." />
                  ) : (
                    <TableOrStackedBarChart />
                  )}
                </div>
              </div>
            }
          />
        ) : null}
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      isLoading: state.totalRevenueSales.isLoading,
      userParams: state.totalRevenueSales.currentUser,
      updatesLoading: state.totalRevenueSales.updatesLoading,
      filtersDirty: state.totalRevenueSales.filtersDirty,
      startDate: state.totalRevenueSales.startDate,
      endDate: state.totalRevenueSales.endDate,
      toggles: state.totalRevenueSales.filters.toggles,
      chartData: state.totalRevenueSales.chartData
    };
  },
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateChart: actionCreators.updateData,
    resetFilters: actionCreators.resetFilters
  }
)(TotalRevenueSalesModule);

TotalRevenueSalesModule.propTypes = {
  currentUser: PropTypes.object,
  fetchCurrentUser: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  filtersDirty: PropTypes.bool,
  updateChart: PropTypes.func,
  resetFilters: PropTypes.func,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  updatesLoading: PropTypes.bool,
  toggles: PropTypes.shape({
    includeReturns: PropTypes.object,
    showExpenses: PropTypes.object
  })
};
